import React, { useEffect, useRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { filterChildrenByType } from '@fiverr-private/ui_utils';
import { Container } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { type BreadcrumbsProps } from './types';
import { hideScrollbar } from './styles.ve.css';
import { colorMap, linkPrimary } from './constants';

const Breadcrumbs = ({ color = linkPrimary, children, ...restProps }: BreadcrumbsProps) => {
  const breadcrumbsRef = useRef<HTMLElement>(null);
  const items = filterChildrenByType(children, 'BreadcrumbsLink');
  const textColor = colorMap[color];

  useEffect(() => {
    if (breadcrumbsRef.current) {
      const { scrollWidth, clientWidth } = breadcrumbsRef.current;
      breadcrumbsRef.current.scrollLeft = scrollWidth - clientWidth;
    }
  }, []);

  return (
    <Container
      as="nav"
      overflowX="auto"
      maxWidth="100%"
      display="inlineBlock"
      style={{ scrollBehavior: 'smooth', scrollbarWidth: 'none' }}
      aria-label={translate<string>('navigation.breadcrumb.ariaLabel')}
      ref={breadcrumbsRef}
      paddingY="1"
      paddingLeft="1.5"
      color={textColor}
      className={hideScrollbar}
    >
      <Box as="ol" boxSizing="borderBox" display="flex" alignItems="center" gap="2" {...restProps}>
        {items.map((item, index) => (
          <>
            {index !== 0 && (
              <Container key={`Sep${index}`} role="presentation" as="li" color="grey_600">
                /
              </Container>
            )}
            {item}
          </>
        ))}
      </Box>
    </Container>
  );
};

Breadcrumbs.displayName = 'Breadcrumbs';
export default Breadcrumbs;
